import { DatatableComponent } from "@swimlane/ngx-datatable";
import { NavigationExtras, Router } from "@angular/router";
import { LoadingService } from "./../../../util/loader.service";
import { ActivatedRoute } from "@angular/router";
import { trigger, state, style, transition, animate } from '@angular/animations';

import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  Injector,
  ViewEncapsulation
} from "@angular/core";
import { NotificacaoService } from "../notificacao/notificacao.service";
import { RelatorioFaturamentoCartaoFidelidadeService } from "./relatorio-faturamento-cartao-fidelidade.service";
import { DatepickerOptions } from "ng2-datepicker";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import RelatorioFaturamentoCartaoFidelidadeFiltro from "../../../models/relatorio-faturamento-cartao-fidelidade/relatorio-faturamento-cartao-fideliade-filtro.model";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import RelatorioFaturamentoCartaoFidelidadeInformacao from "../../../models/relatorio-faturamento-cartao-fidelidade/relatorio-faturamento-cartao-fidelidade-informacao.model";

const swal = require("sweetalert");

@Component({
  selector: 'app-relatorio-faturamento-cartao-fidelidade',
  templateUrl: './relatorio-faturamento-cartao-fidelidade.component.html',
  styleUrls: ['./relatorio-faturamento-cartao-fidelidade.component.scss'],
  animations: [
    trigger('filterBlur', [
      state(
        'hide',
        style({
          opacity: 1
        })
      ),
      state(
        'show',
        style({
          opacity: 0
        })
      ),
      transition('hide => show', animate('200ms ease-in')),
      transition('show => hide', animate('200ms ease-out'))
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class RelatorioFaturamentoCartaoFidelidadeComponent implements OnInit {


  rows: Object[];
  selectCheck;
  selected = [];
  registroSelecao = [];
  parametroConsulta: string;
  filterState: boolean = true;
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    descricao: "",
    ativo: true
  };
  mesagensGrid = {
    emptyMessage: "Nenhum dado para exibir",
    totalMessage: "Total de registros",
    selectedMessage: "Selecionado"
  };
  acoesBottoes: boolean = true;
  sortDir: string = "";
  sortProp: string = "";
  @ViewChild('tableNotificacao') table: any;
  ocultarFiltros: any;
  blur = false;
  options: DatepickerOptions = {
    displayFormat: 'DD/MM/YYYY',
    barTitleIfEmpty: 'Clique para selecionar a data',
    placeholder: 'Clique para selecionar a data'
  };
  keep = true;
  filtroExibido = false;
  valForm: FormGroup;
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  bsConfig = {
    containerClass: 'theme-angle',
    dateInputFormat: 'DD/MM/YYYY'
  };
  filtrosAplicados: string;
  parametro: RelatorioFaturamentoCartaoFidelidadeFiltro;
  informacao: RelatorioFaturamentoCartaoFidelidadeInformacao;
  ngOnDestroy(): void { }

  constructor(
    public service: RelatorioFaturamentoCartaoFidelidadeService,
    public injector: Injector,
    private route: ActivatedRoute,
    private router: Router,
    public loader: LoadingService,
    private _localeService: BsLocaleService,
    fb: FormBuilder,
  ) {
    this._localeService.use('pt');
    this.parametro = new RelatorioFaturamentoCartaoFidelidadeFiltro();
    this.informacao = new RelatorioFaturamentoCartaoFidelidadeInformacao();
    this.valForm = fb.group({
      dataInicio: [null, Validators.required],
      dataFim: [null, Validators.required],

    });
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.bsValue, this.maxDate];
    this.parametro.startDate = new Date();
    this.parametro.endDate = this.maxDate;
    this.filtrosAplicados = ''.concat(
      this.trataDataFiltro(
        this.parametro.startDate,
        this.parametro.endDate
      ));
    this.reloadTable();
  }
  ativarFiltros($event) {
    this.blur = !this.blur;
  }
  trataDataFiltro(dataInicio: Date, dataFim: Date): string {
    return ''.concat(
      dataInicio ? dataInicio.toLocaleDateString() : '',
      dataInicio && dataFim ? ' à ' : '',
      dataFim ? dataFim.toLocaleDateString() : '',
      dataInicio || dataFim ? '; ' : ''
    );
  }
  reloadTable() {
    this.loader.show("body");
    this.service.obterTodos(this.page, this.sortDir, this.sortProp, this.parametro).subscribe(itens => {
      this.loader.hide("body");
      this.page.count = itens.count;
      if (itens.rows.length > 0) {
        this.rows = itens.rows;
      } else {
        this.page.offset = 0;
        this.service.obterTodos(this.page, this.sortDir, this.sortProp, this.parametro).subscribe(item => {
          this.page.count = item.count;
          this.rows = item.rows;
        });
      }
    });

    this.service.informacao(this.parametro).subscribe(itens => {
      this.informacao = itens;
    });
  }

  filtro(event) {
    this.page.descricao = this.parametroConsulta;
    this.reloadTable();
  }
  linkEdit() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.parametro.userId = this.registroSelecao[0].id_usuarios;
      this.parametro.data = this.registroSelecao[0];
      let navigationExtras: NavigationExtras = {
        queryParams: {
          "data": JSON.stringify(this.parametro),
        },
        skipLocationChange: true
      };
      this.router.navigate(['/fidel/relatorio-faturamento-cartao-fidelidade/detalhe'], navigationExtras);
    }
  }
  onFilterChange(eve: any) {
    this.page.ativo = eve;
    this.reloadTable();
  }
  pesquisar($ev, value) {
    this.page.offset = 0;

    this.blur = false;
    this.reloadTable();
  }
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.registroSelecao = [];
    this.selected = [];
    this.reloadTable();
  }



  ngOnInit() { }

  onSort(event) {
    this.sortDir = event.sorts[0].dir;
    this.sortProp = event.sorts[0].prop;
    this.page.offset = 0;
    this.reloadTable();
  }

  limparSelecionados() {
    this.registroSelecao = [];
    this.selected = [];
    this.acoesBottoes = true;

    this.onSelect({ selected: [] });
    this.table.selected = [];

    var inputs = document.getElementsByTagName('input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('type') == 'checkbox') {
        inputs[i].checked = false;
      }
    }
  }
  marcarCheck(codigo) {
    let x = false;
    this.selected.forEach(item => {
      if (item.id_usuarios == codigo) {
        x = true;
      }
    });
    return x;
  }

  removeItemDuplicado(array) {
    array.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))
    return array;
  }

  removerItem(array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].id_usuarios == item[0].id_usuarios) {
        array.splice(i, 1);
      }
    }

    return array;
  }

  pegarDiferenca(r1, r2) {
    let r3 = r1.filter(a => !r2.includes(a));
    return (r3);
  }


  onSelect(event) {
    let itens = event.selected;

    let itensSemduplicacao = itens.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    let itemSerRemovido = this.pegarDiferenca(itens, itensSemduplicacao);
    try {
      itens = this.removerItem(itensSemduplicacao, itemSerRemovido);
    } catch (error) {
      //ignore, tudo certo
    }
    this.selected = itens;
    event.selected = itens;

    if (event.selected.length > 0) {
      this.registroSelecao = event.selected;
      this.acoesBottoes = false;
    } else {
      this.acoesBottoes = true;
    }
  }

}
